import { createRoot } from "react-dom/client";
import App from "./App";
import { developmentLog } from "@helpers/developmentLog";
import "./styles.css";

console.log("Initializing client...");

const PARCEL_ENVIRONMENT = process.env.PARCEL_ENVIRONMENT;

if (!PARCEL_ENVIRONMENT) {
  throw new Error("PARCEL_ENVIRONMENT environment variable is not set");
} else developmentLog(`PARCEL_ENVIRONMENT: ${PARCEL_ENVIRONMENT}`);

const PARCEL_API_URL = process.env.PARCEL_API_URL;

if (!PARCEL_API_URL) {
  throw new Error("PARCEL_API_URL environment variable is not set");
} else developmentLog(`PARCEL_API_URL: ${PARCEL_API_URL}`);

createRoot(document.getElementById("root")!).render(<App />);

developmentLog("Client initialized successfully");
